
<span v-if="item.text" class="tag-label">
  <component :is="item.icon" v-if="item.icon" :width="16" :height="16" color="#282930" class="min-w-16" />
  {{ item.text }}
</span>
